import styled from 'styled-components';

/** The two exports of this tab, side by side in the header of the section. */
export const ExportActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px 12px;

  button {
    width: auto;
  }
`;
